export const AppRoutes = {
    SIGNUP: "/signup",
    REQUEST: "/request",
    REQUEST_DETAILS: "/request/detail/:id",
    ADD_REQUEST: "/request/add",
    REQUEST_ABOUT_SECURITY: "/request/about-security",
    REQUEST_ABOUT_IOS: "/request/about-ios",
    CALLBACK: "/signing-callback",
    ABOUT_SECURITY: "/about-security",
    ABOUT_IOS: "/about-ios",
};
